<header class="masthead">
  <div class="container h-100">
    <div class="row h-100 align-items-center">
      <div class="col-12 text-center">
        <h1 class="outline-title">Data Science</h1>
      </div>
    </div>
  </div>
</header>

<section class="modern-service-hero-section py-5">
  <div class="container px-5 my-5">
    <div class="row align-items-center">
      <div class="col-lg-7">
        <a class="service-detail-back" routerLink="/servicios">
          <i class="bi bi-arrow-left"></i>
          Servicios
        </a>
        <h1 class="modern-section-title mb-3">
          Data Science para tomar <span class="highlight-green">mejores decisiones</span>
        </h1>
        <div class="section-underline"></div>
        <p class="lead text-light mb-4">
          Transformamos datos en insights accionables para optimizar procesos, audiencias y crecimiento.
        </p>
        <ul class="modern-checklist">
          <li><i class="bi bi-check-circle-fill"></i> Modelos predictivos y machine learning</li>
          <li><i class="bi bi-check-circle-fill"></i> Optimización de procesos comerciales</li>
          <li><i class="bi bi-check-circle-fill"></i> Segmentación y personalización</li>
        </ul>
      </div>
      <div class="col-lg-5 text-center">
        <app-service-orbit-visual iconClass="bi bi-database"></app-service-orbit-visual>
      </div>
    </div>
  </div>
</section>

<!-- CARDS DE SERVICIOS -->
<section class="modern-service-cards-section py-5">
  <div class="container">
    <div class="row g-4">
      <div class="col-md-4 d-flex">
        <div class="modern-service-card glass-card w-100 text-center">
          <div class="icon-box mx-auto mb-3">
            <i class="bi bi-cpu"></i>
          </div>
          <h4 class="modern-service-card-title">Machine Learning</h4>
          <p>Implementamos modelos predictivos personalizados para anticipar comportamiento y optimizar decisiones.</p>
        </div>
      </div>
      <div class="col-md-4 d-flex">
        <div class="modern-service-card glass-card w-100 text-center">
          <div class="icon-box mx-auto mb-3">
            <i class="bi bi-pie-chart"></i>
          </div>
          <h4 class="modern-service-card-title">Visualización de Datos</h4>
          <p>Convertimos datos complejos en dashboards claros para interpretar KPIs y oportunidades.</p>
        </div>
      </div>
      <div class="col-md-4 d-flex">
        <div class="modern-service-card glass-card w-100 text-center">
          <div class="icon-box mx-auto mb-3">
            <i class="bi bi-graph-up-arrow"></i>
          </div>
          <h4 class="modern-service-card-title">Analítica Avanzada</h4>
          <p>Identificamos patrones, tendencias y oportunidades estratégicas dentro de tu operación.</p>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- SECCIÓN POR QUÉ ELEGIRNOS -->
<section class="modern-service-why-section py-5">
  <div class="container px-5 my-5">
    <div class="row align-items-center">
      <div class="col-md-6">
        <h2 class="modern-section-title mb-3">
          ¿Por qué <span class="highlight-green">elegirnos?</span>
        </h2>
        <div class="section-underline"></div>
        <ul class="modern-checklist">
          <li><i class="bi bi-check-circle-fill"></i> Experiencia técnica y analítica combinada
          </li>
          <li><i class="bi bi-check-circle-fill"></i> Enfoque personalizado para objetivos
            específicos</li>
          <li><i class="bi bi-check-circle-fill"></i> Insights claros para decisiones informadas</li>
        </ul>
      </div>
      <div class="col-md-6">
        <div class="glass-card p-4">
          <p class="mb-0 text-light">
            Convierte tus datos en ventaja competitiva.
          </p>
        </div>
      </div>
    </div>
  </div>
</section>
